import Vue from "vue";
import Router from "vue-router";

import { getSignToken, getUser } from "../util/auth";
import { loadLanguageAsync } from "../i18n";
import { DEVICE_TYPE } from "@/constant";

Vue.use(Router);

const router = new Router({
  mode: "history",

  routes: [
    {
      path: '/cloudGame/:id',
      component: () => import('@/views/pages/cloudgame/CloudGame.vue'),
    },
    {
      path: '/hok/cookiesPolicy',
      component: () => import('@/views/pages/policy/CookiesPolicy.vue'),
    },
  ],

});

router.beforeEach(async (to, from, next) => {
  let lang = 'en';
  if (window.location.host == "cloudgame-br.qcloud.com") {
    lang = "pt";
  }
  if (window.location.href.indexOf("bbg7bb") > -1) {
    lang = "pt";
  }
  await loadLanguageAsync(lang);
  // // 暂时兼容pc
  // if (DEVICE_TYPE.isPC && (window.location.pathname.includes("cloudGame"))) {
  //   let url = window.location.href;
  //   url = url.replace("cloudGame", "pc/game");
  //   window.location.href = url;
  // } else {
  //   next();
  // }

  next();
});

export default router;
